module.exports = __webpack_public_path__ + "img/12.33fec08f.png";